import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

/**
 * Kebab (⋮) row-actions cell for DataGrid `type: 'actions'` columns and for
 * the mobile card-list fallback. `actions`: [{ label, icon, onClick, color? }].
 */
export default function RowActionsMenu({ actions, ariaLabel = 'Ações' }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton size="small" aria-label={ariaLabel} onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {actions.map((item) => (
          <MenuItem
            key={item.label}
            onClick={(event) => {
              event.stopPropagation();
              handleClose();
              item.onClick();
            }}
            sx={item.color ? { color: `${item.color}.main` } : undefined}
          >
            {item.icon && (
              <ListItemIcon sx={item.color ? { color: `${item.color}.main` } : undefined}>
                {item.icon}
              </ListItemIcon>
            )}
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
